import { Typography } from '@arionbanki/arionui';
import { BULK_FLOW_TYPES, MAX_ENTRIES } from './BulkCancel.consts';
import type { BulkCancelHook } from './useBulkCancel';

type BulkCancelInputStepProps = { bulk: BulkCancelHook };

export function BulkCancelInputStep({ bulk }: Readonly<BulkCancelInputStepProps>) {
	const { t } = bulk;
	return (
		<>
			<Typography TagName="h4">{t('admin_bulk_cancel_title') || 'Bulk cancel processes'}</Typography>
			<Typography TagName="p">
				{t('admin_bulk_cancel_description') ||
					'Paste a list of kennitalas, pick the flow type and preview which processes would be cancelled.'}
			</Typography>

			<label className="admin-drawer-label" htmlFor="bulk-flow-type">
				{t('admin_bulk_flow_type') || 'Flow type'}
			</label>
			<select
				className="admin-filter admin-bulk__select"
				id="bulk-flow-type"
				onChange={bulk.onFlowType}
				value={bulk.flowType}
			>
				<option value="">{t('admin_bulk_select_flow') || 'Select flow type'}</option>
				{BULK_FLOW_TYPES.map(flow => (
					<option key={flow.value} value={flow.value}>
						{t(`flow-type-${flow.value}`) || flow.fallback}
					</option>
				))}
			</select>

			<label className="admin-drawer-label" htmlFor="bulk-kennitalas">
				{t('admin_bulk_kennitalas') || 'Kennitalas (one per line or comma-separated)'}
			</label>
			<textarea
				className="admin-bulk__textarea"
				id="bulk-kennitalas"
				onChange={bulk.onText}
				placeholder={'0101302989\n010130-2719'}
				rows={10}
				value={bulk.text}
			/>
			<div className="admin-bulk__meta">
				{t('admin_bulk_entry_count') || 'Entries'}: {bulk.entries.length} / {MAX_ENTRIES}
			</div>

			{bulk.error && <div className="admin-bulk-message admin-bulk-message--error">{bulk.error}</div>}

			<div className="admin-drawer-actions__row">
				<button
					className="admin-drawer-btn admin-drawer-btn--update"
					disabled={!bulk.canPreview}
					onClick={bulk.runPreview}
					type="button"
				>
					{t('admin_bulk_preview_btn') || 'Preview'}
				</button>
			</div>
		</>
	);
}
